// apiConfig.js



const currentUrl = window.location.href;
console.log("Current URL:", currentUrl);


const urlObject = new URL(currentUrl);


const dynamicBaseURL = urlObject.port 
  ? `${urlObject.protocol}//${urlObject.hostname}:${urlObject.port}` 
  : `${urlObject.protocol}//${urlObject.hostname}`;

// Use the dynamic base URL
export const baseURL = dynamicBaseURL;
// export const baseURL = 'http://10.226.25.103:8080';